import React, {createRef, RefObject, useContext} from "react";
import {Helmet} from "react-helmet-async";
import {
    Grid,
    Divider as MuiDivider,
    Typography,
    Button, Menu, MenuItem
} from "@mui/material";
import ListViewTable from "../../components/ListViewTable";
import {ApprovalsContext} from "./store/approvals-context";

// Types
import {HeadCell} from "../../../types/headCell";

// Styling
import styled from "styled-components/macro";
import {spacing} from "@mui/system";
import {Add as AddIcon, Edit, FileDownload, FileUpload, MoreHoriz} from "@mui/icons-material";
import SearchBar from "../../components/SearchBar";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

const Input = styled('input')({display: 'none',});
const Divider = styled(MuiDivider)(spacing);

function Approvals() {
    const approvalsCtx = useContext(ApprovalsContext);
    const fileInput: RefObject<HTMLInputElement> = createRef();

    // Set table headers data
    const headCells: Array<HeadCell> = approvalsCtx.headers;

    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    //------------------------------- Public methods -------------------------------------


    return (
        <React.Fragment>
            <Helmet title="Benefits"/>
            <Grid item xs={12} mb={10}>
                <Typography variant="h1" gutterBottom display="inline">
                    Benefits
                </Typography>

            </Grid>
            <Grid justifyContent="space-between" container spacing={10} mb={10}>
                <Grid item>
                    <SearchBar text={approvalsCtx.search} onSearch={approvalsCtx.onSearch}/>
                </Grid>
                <Grid item>
                    <div>
                        <Button variant="contained" color="primary" className="margin-right-btn" onClick={approvalsCtx.addItem} startIcon={<AddIcon/>}>
                            New Benefit
                        </Button>
                        <Button
                            id="options-button"
                            aria-controls={open ? 'options-menu' : undefined}
                            aria-haspopup="true"
                            aria-expanded={open ? 'true' : undefined}
                            variant="contained"
                            disableElevation
                            onClick={handleClick}
                        >
                            <MoreHoriz/>
                        </Button>
                        <Menu
                            id="options-menu"
                            MenuListProps={{
                                'aria-labelledby': 'options-button',
                            }}
                            anchorEl={anchorEl}
                            open={open}
                            onClose={handleClose}
                            elevation={0}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'right',
                            }}
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                        >
                            <MenuItem onClick={(event: any) => {
                                if (approvalsCtx.exportCsv) {
                                    approvalsCtx.exportCsv('csv')
                                }
                                handleClose()
                            }} disableRipple>
                                <FileDownload/>
                                CSV Export Benefits
                            </MenuItem>
                            <MenuItem onClick={(event: any) => {
                                if (approvalsCtx.exportCsv) {
                                    approvalsCtx.exportCsv('xls')
                                }
                                handleClose()
                            }} disableRipple>
                                <FileDownload/>
                                XLS Export Benefits
                            </MenuItem>

                            <MenuItem onClick={(event: any) => {
                                if (fileInput.current) {
                                    fileInput.current.click();
                                }
                                handleClose()
                            }} disableRipple>
                                <FileUpload/>
                                CSV/XLS Import Benefits
                            </MenuItem>

                            {approvalsCtx.selected && approvalsCtx.selected?.length > 0 &&
                                <div>
                                    <Divider sx={{my: 0.5}}/>
                                    <MenuItem onClick={approvalsCtx.multiEdit} disableRipple>
                                        <Edit/>
                                        Multi Edit
                                    </MenuItem>
                                </div>
                            }
                        </Menu>
                        <Input
                            ref={fileInput}
                            accept=".csv,.xlsx,.xls"
                            type="file"
                            name="file"
                            onChange={(event: any) => {
                                if (approvalsCtx.importCsv) {
                                    approvalsCtx.importCsv(event.target.files)
                                }
                            }}
                        />
                        {/*<Button variant="contained" color="primary" onClick={(event: any) => {*/}
                        {/*    if (approvalsCtx.exportCsv) {*/}
                        {/*        approvalsCtx.exportCsv('csv')*/}
                        {/*    }*/}
                        {/*}}*/}
                        {/*        startIcon={<FileDownload/>} className="margin-right-btn">*/}
                        {/*    CSV Export Benefits*/}
                        {/*</Button>*/}
                        {/*<Button variant="contained" color="primary" onClick={(event: any) => {*/}
                        {/*    if (approvalsCtx.exportCsv) {*/}
                        {/*        approvalsCtx.exportCsv('xls')*/}
                        {/*    }*/}
                        {/*}}*/}
                        {/*        startIcon={<FileDownload/>} className="margin-right-btn">*/}
                        {/*    XLS Export Benefits*/}
                        {/*</Button>*/}
                        {/*<Input*/}
                        {/*    ref={fileInput}*/}
                        {/*    accept=".csv,.xlsx,.xls"*/}
                        {/*    type="file"*/}
                        {/*    name="file"*/}
                        {/*    onChange={(event: any) => {*/}
                        {/*        if (approvalsCtx.importCsv) {*/}
                        {/*            approvalsCtx.importCsv(event.target.files)*/}
                        {/*        }*/}
                        {/*    }}*/}
                        {/*/>*/}
                        {/*<Button variant="contained" color="primary" onClick={(e: any) => {*/}
                        {/*    if (fileInput.current) {*/}
                        {/*        fileInput.current.click();*/}
                        {/*    }*/}
                        {/*}} startIcon={<FileUpload/>} className="margin-right-btn">*/}
                        {/*    CSV/XLS Import Benefits*/}
                        {/*</Button>*/}
                        {/*{approvalsCtx.selected && approvalsCtx.selected?.length > 0 &&*/}
                        {/*    <Button variant="contained" color="primary" onClick={approvalsCtx.multiEdit} className="multi-btn" startIcon={<Edit />} >*/}
                        {/*        Multi edit*/}
                        {/*    </Button>*/}
                        {/*}*/}
                        {/*<Button variant="contained" color="primary" onClick={approvalsCtx.addItem}>*/}
                        {/*    <AddIcon/>*/}
                        {/*    New Benefit*/}
                        {/*</Button>*/}
                    </div>
                </Grid>
            </Grid>

            <Grid item xs={12} className="shadow">
                <ListViewTable
                    key='list'
                    rows={approvalsCtx.items}
                    tableHeaders={headCells}
                    onDeleteHandler={approvalsCtx.removeItem}
                    onSelectHandler={approvalsCtx.selectItem}
                    onPaginateHandler={approvalsCtx.onPaginate}
                    onSortHandler={approvalsCtx.onSort}
                    count={approvalsCtx.count}
                    page={approvalsCtx.page}
                    rowsPerPage={approvalsCtx.rowsPerPage}
                    sorting={approvalsCtx.sorting}
                    filters={approvalsCtx.filters}
                    onMultiEditHandler={approvalsCtx.multiSelected}
                    selectedArray = {approvalsCtx.selected}
                />
            </Grid>
        </React.Fragment>
    );
}

export default Approvals;
